import { render, staticRenderFns } from "./infoMessage.vue?vue&type=template&id=6ad2105e&scoped=true&"
import script from "./infoMessage.vue?vue&type=script&lang=js&"
export * from "./infoMessage.vue?vue&type=script&lang=js&"
import style0 from "./infoMessage.vue?vue&type=style&index=0&id=6ad2105e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2105e",
  null
  
)

export default component.exports